<template>
    <eventi-view-component :jsonData="jsonData" :pathResource="pathResource" :pathResourceFirma="pathResourceFirma" :utente="utente" :titoloEvento="titoloEvento" :linkPrintData="linkPrintData">
        <template slot="tab-content-event">
            <coronarografia-ptca-view-component :idEvento="id" @update="onUpdateJsonData"></coronarografia-ptca-view-component>
        </template>
    </eventi-view-component>
</template>
<script>
import UtilityMixins from "../../../../../utility/UtilityMixin";
import EventiMixins from "../../../utility/mixins/EventiMixins";
import EventiViewComponent from "../../../base/components/EventiViewComponent.vue";
import CoronarografiaPtcaViewComponent from "./CoronarografiaPtcaViewComponent.vue";

export default {
    mixins: [UtilityMixins, EventiMixins],
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    components: { CoronarografiaPtcaViewComponent, EventiViewComponent },
    data() {
        return {
            titoloEvento: "Coronarografia PTCA",
            linkback: null,
            pathResource: "/cardiocoronarografieptca",
            pathResourceFirma: "/cardiocoronarografieptca",
            jsonData: {},
            tabIndex: 0,
            id: null,
            showModalLoading: false,
            linkPrintData: null,
            fontScale: 2,
            linkedit: null,
            pathRestValidation: "/validation",
            isThisFirmato: false,
        };
    },
    computed: {
        idPaziente() {
            return this.$route.query.idPaziente;
        },
        linkPatient() {
            return EventiMixins.getLinkPatient(this.utente, this.idPaziente);
        },
    },
    mounted() {
        let me = this;
        me.jsonData.idPaziente = this.$route.query.idPaziente;
        me.id = this.$route.params.id;
    },
    methods: {
        updateStatoFirma(firmato) {
            console.log(firmato);
        },
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
            me.linkPrintData = "/pazienteeventi/print/" + me.jsonData.id;
        },
    },
};
</script>
